export default __webpack_public_path__ + "./images/ku.bb451c9f.png";